import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  Injector,
  Input,
  OnInit,
  QueryList,
  TemplateRef,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { PrimeTemplate } from 'primeng/api';

import { FORM_VALIDATION_ERROR_MSG_MAP } from '../../../core/constants/message.constant';
import { isNullOrEmpty } from '../../../core/utils/common-functions';
import {
  getFormGroupEx,
  showValidationMessage,
} from '../../../core/utils/validator-functions';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'sigv-form-control-widget',
  templateUrl: './form-control-widget.component.html',
  styleUrls: ['./form-control-widget.component.scss'],
})
export class FormControlWidgetComponent
  extends BaseComponent
  implements OnInit, AfterViewInit
{
  readonly validationMsgMap = FORM_VALIDATION_ERROR_MSG_MAP;
  readonly requiredKeys = ['required', 'startRequired', 'endRequired'];

  readonly ignoredKeys = [
    'invalidDate',
    'startRequired',
    'endRequired',
    'rangeInvalid',
    'startInvalidDate',
    'endInvalidDate',
  ];
  @Input() fieldName?: string;
  @Input() bindingFormControl?: AbstractControl | any;
  @ContentChildren(PrimeTemplate) templates!: QueryList<PrimeTemplate>;
  messagesTemplate!: TemplateRef<any>;
  showErrorMsg = false;
  translateParams?: { [key: string]: string | undefined };

  constructor(private injector: Injector, private cd: ChangeDetectorRef) {
    super(injector);
    if (this.bindingFormControl?.displayName) {
      this.fieldName = this.bindingFormControl?.displayName;
    }
  }

  get errorKeys(): string[] {
    this.bindingFormControl;
    if (isNullOrEmpty(this.bindingFormControl)) {
      return [];
    }
    const keys = Object.keys(this.bindingFormControl!.errors ?? {}).filter(
      (x) => this.ignoredKeys.includes(x) === false
    );
    if (keys.some((x) => this.requiredKeys.includes(x))) {
      return keys.filter((x) => this.requiredKeys.includes(x));
    }
    return keys;
  }
  getMsgByKey(key: string, map: typeof FORM_VALIDATION_ERROR_MSG_MAP) {
    const useKey = key as keyof typeof this.validationMsgMap;
    let useMsg = map[useKey];
    return useMsg;
  }
  processMsg(useMsg: string) {
    useMsg = useMsg.replace(
      '{{actualLength}}',
      String(this.bindingFormControl?.errors?.['maxlength']?.['actualLength'])
    );
    useMsg = useMsg.replace(
      '{{requiredLength}}',
      String(this.bindingFormControl?.errors?.['maxlength']?.['requiredLength'])
    );
    useMsg = useMsg.replace(
      '{{currentLength}}',
      String(this.bindingFormControl?.errors?.['minlength']?.['actualLength'])
    );
    useMsg = useMsg.replace(
      '{{minimumLength}}',
      String(this.bindingFormControl?.errors?.['minlength']?.['requiredLength'])
    );
    useMsg = useMsg.replace(
      '{{rangeYaer}}',
      String(this.bindingFormControl?.errors?.['exceedMaxDateRange']?.['range'])
    );
    useMsg = useMsg.replace(
      '{{maxDateComp}}',
      String(this.bindingFormControl?.errors?.['maxDateComp']?.['maxDate'])
    );
    useMsg = useMsg.replace(
      '{{minDateComp}}',
      String(this.bindingFormControl?.errors?.['minDateComp']?.['minDate'])
    );
    return useMsg;
  }

  ngOnInit(): void {
    if (isNullOrEmpty(this.fieldName) === false) {
      const displayName = this.translateService.instant(this.fieldName!);
      this.translateParams = { field: displayName };
    }

    this.translateService.onLangChange.subscribe({
      next: (lang: any) => {
        if (isNullOrEmpty(this.fieldName) === false) {
          const displayName = this.translateService.instant(this.fieldName!);
          this.translateParams = { field: displayName };
        }
      },
    });
  }

  ngAfterViewInit(): void {
    this.templates.forEach((item) => {
      switch (item.getType()) {
        case 'messages':
          this.messagesTemplate = item.template;
          break;
        default:
          break;
      }
    });
    this.cd.detectChanges();
  }

  showValidationMessage(): boolean {
    if (isNullOrEmpty(this.bindingFormControl)) {
      return false;
    }
    const formEx = getFormGroupEx(this.bindingFormControl!);
    return showValidationMessage(
      this.bindingFormControl!,
      formEx?.submitted ?? false
    );
  }
}
